import injector from 'vue-inject'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    signInStatus: injector.get('userSignInStatusType').signedOut,
    permissions: {},
    stores: null,
    // from firebase
    uid: null,
    displayName: '',
    email: '',
    photoURL: '',
    providerData: []
  },
  getters: {
  },
  mutations,
  actions
}
